export enum COOKIES {
  AUTH_COOKIE = 'livingas1',
}

export enum EventType {
  EVENT = 'event',
  WEB_EVENT = 'webevent',
}

export enum KEYS {
  ESCAPE_KEY = 27,
}

export interface User {
  userId: string;
  userName: string;
  userType: string;
  customerId: string;
  customerName?: string;
  features: string[];
  toggles: string[];
  capabilities: string[];
}

export interface DataCenter {
  readonly id: string;
  readonly url: string;
  readonly displayName: string;
}

export interface LatencyDetails {
  dataCenter: DataCenter;
  duration: number;
  isPassing: boolean;
}

export const DATA_CENTERS: readonly DataCenter[] = [
  {
    id: '1290ae83-b319-4cf4-9069-41a7296c8c2c',
    url: 'https://broker-proxy-us-central1.livingasone.com/api/v1/ping',
    displayName: 'North America',
  },
  {
    id: '4a42f2d6-56d2-4ff0-9ee8-3b23ac3ac454',
    url: 'https://broker-proxy-asia-southeast1.livingasone.com/api/v1/ping',
    displayName: 'Asia',
  },
  {
    id: '66418af3-985b-4abb-9ec0-6868f7c523ee',
    url: 'https://broker-proxy-australia-southeast1.livingasone.com/api/v1/ping',
    displayName: 'Australia',
  },
  {
    id: '7d856f44-04f0-4b85-8dd9-27cdb92d7668',
    url: 'https://broker-proxy-europe-west4.livingasone.com/api/v1/ping',
    displayName: 'Europe',
  },
  {
    id: 'd31e68ae-22f7-40fb-b2f6-0706730cc957',
    url: 'https://broker-proxy-southamerica-east1.livingasone.com/api/v1/ping',
    displayName: 'South America',
  },
];
